import {useState} from 'react';

export default function useDashboardToken() {
    const getToken = () => {
        return localStorage.getItem('dashboardToken');
    }

    const [token, setToken] = useState(getToken());

    const saveToken = dashboardToken => {
        try {
            console.warn('[DashboardToken] saveToken called:', {
                newValue: dashboardToken,
                previousValue: localStorage.getItem('dashboardToken'),
                stack: (new Error()).stack,
            })
        } catch (e) {
            console.error('[DashboardToken] Error logging token info:', e);
        }

        if (dashboardToken === null) {
            localStorage.removeItem('dashboardToken');
        } else {
            localStorage.setItem('dashboardToken', dashboardToken);
        }
        setToken(dashboardToken)
    }

    return {
        setPhysicianDashboardToken: saveToken,
        physicianDashboardToken: token
    }
}
